import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

export default function Footer(){
  return (
    <div className="mt-16 py-12 text-white">
      <div className="flex flex-col items-center gap-6">
        <h3 className="font-bold text-2xl gradient-text">Let's connect</h3>
        <p className="text-slate-500 text-sm max-w-md text-center">Open to discussing new opportunities, collaborations, or just talking tech.</p>

        <div className="flex gap-3 mt-2">
          <a href='https://github.com/vimaljais' rel="noreferrer" target="_blank" className="w-11 h-11 rounded-xl bg-dark-200 border border-slate-700/30 flex items-center justify-center hover:bg-indigo-500/10 hover:border-indigo-400/40 hover:scale-110 transition-all duration-300 text-slate-400 hover:text-white">
            <FontAwesomeIcon size='lg' icon={faGithub} />
          </a>
          <a href='https://www.linkedin.com/in/vimaljais' rel="noreferrer" target="_blank" className="w-11 h-11 rounded-xl bg-dark-200 border border-slate-700/30 flex items-center justify-center hover:bg-indigo-500/10 hover:border-indigo-400/40 hover:scale-110 transition-all duration-300 text-slate-400 hover:text-white">
            <FontAwesomeIcon size='lg' icon={faLinkedinIn} />
          </a>
        </div>

        <div className="flex gap-6 mt-4 text-slate-500 text-xs">
          <a href="#home" className="hover:text-slate-300 transition-colors">About</a>
          <a href="#skills" className="hover:text-slate-300 transition-colors">Skills</a>
          <a href="#employment" className="hover:text-slate-300 transition-colors">Employment</a>
        </div>

        <p className="text-slate-700 text-xs mt-6">&copy; {new Date().getFullYear()} Vimal Jaiswal</p>
      </div>
    </div>
  )
}
